import { render, staticRenderFns } from "./storeAuthorizeList.vue?vue&type=template&id=b89b6af0&scoped=true&"
import script from "./storeAuthorizeList.vue?vue&type=script&lang=js&"
export * from "./storeAuthorizeList.vue?vue&type=script&lang=js&"
import style0 from "./storeAuthorizeList.vue?vue&type=style&index=0&id=b89b6af0&scoped=scoped&lang=css&"
import style1 from "./storeAuthorizeList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b89b6af0",
  null
  
)

export default component.exports